export const productCategoryEnum = {
    1000: { text: 'RCS', status: 'Default'},
    2000: { text: 'WS', status: 'Default' },
    3000: { text: 'SMS', status: 'Default' }
}

export const apiTypeEnum = {
    1: { text: '料子筛选', status: 'Default'},
    2: { text: '消息发送', status: 'Success' },
}

export const apiTypeOptions = [
    { label: '料子筛选', value: 1},
    { label: '消息发送', value: 2},
]

export const MessageStateEnum = {
    11: { text: '审核中', status: 'Processing'},
    12: { text: '审核通过', status: 'Success'},
    13: { text: '审核驳回', status: 'Error' },
    20: { text: '待发送', status: 'Default'},
    21: { text: '发送中', status: 'Processing'},
    22: { text: '发送完成', status: 'Success'},
    23: { text: '发送终止', status: 'Warning' },
    24: { text: '发送失败', status: 'Error' },
    29: { text: '取消发送', status: 'Default'}
}

export const userStatusEnum = {
    1: {text: '正常', status: 'Success'},
    2: {text: '冻结/不可用', status: 'Error'}
}

export const authenticationStatusMap = {
    0 : {text: "未认证", color: "gray", status: 'Default'},
    1 : {text: "认证中", color: "blue", status: 'Default'},
    2 : {text: "已认证", color: "green", status: 'Success'},
    3 : {text: "驳回认证", color: "volcano", status: "Error"}
}

export const authenticationExemptMap = {
    0 : {text: "需认证", status: 'Default'},
    1 : {text: "免认证", status: 'Success'}
}

export const submitTypeMap = {
    1 : {text: "单条提交（同步结果）", status: 'Default'},
    2 : {text: "多条提交（同步结果）", status: 'Default'},
    3 : {text: "文件提交（异步结果）", status: 'Default'}
}
export const submitTypeOptions = [
    {value: 1 , label : "单条提交（同步结果）"},
    {value: 2 , label : "多条提交（同步结果）"},
    {value: 3 , label : "文件提交（异步结果）"}
]

export const countryFilterTypeOptions = [
    {value: 1 , label : "全部国家"},
    {value: 2 , label : "包含所选国家"},
    {value: 3 , label : "排除所选国家"}
]

export const apiConfigActionTypeOptions = [
    {value: 1 , label : "设置接口"},
    {value: 2 , label : "清除接口（清除后将使用默认配置（如有））"}
]

export const priceConfigActionTypeOptions = [
    {value: 1 , label : "设置价格"},
    {value: 2 , label : "清除价格（清除后将使用默认配置价格（如有））"}
]

export const apiStatusMap = {
    1: {text: '正常', status: 'Success'},
    2: {text: '暂停', status: 'Error'}
}

export const AUTH = {
    ADMIN : 1,
    AGENT : 2,
    USER : 3,
    SUPER_ADMIN : 9
}

export const sendStateEnum = {
    0 : {text: "未发送", status: "Default"},
    1 : {text: "发送成功", status: "Success"},
    2 : {text: "发送失败", status: "Error"},
    3 : {text: "发送终止", status: "Error"},
}

export const deliveryStateEnum = {
    0 : {text: "未知", status: "Default"},
    1 : {text: "接收成功", status: "Success"},
    2 : {text: "接收失败", status: "Error"}
}

export const detectionUserStatusEnum = {
    0: { text: '待检测', status: 'Default'},
    1: { text: '检测中', status: 'Processing'},
    2: { text: '检测成功', status: 'Success' },
    3: { text: '检测失败', status: 'Error'}
}
